import {
    Collisions,
    GameStorageManager,
    Inject,
    ModelEvents,
    Singleton,
    SoundManager,
} from '@denishussar/html5-game-engine';
import {
    AppStateEnum,
    GameCollectableTypeEnum,
    GameModel,
    GameMoveableObstacleTypeEnum,
    GameObstacleTypeEnum,
    GamePlayerTypeEnum,
} from '../Models/GameModel';
import { getCarConfigByType, getCommonConfig, getTileConfig, getUpgradeConfig } from '../Common/GameConfig';
import { sampleFromArray } from '../Common/Utils';
import { Sounds } from '../Constants/Sounds';
import { Random } from '../Utils/Math';
import { InchGenerator } from './Generator/Generator';
import { EngineEvents, GeneratorEvenets, UIEvents } from '../Constants/Events';
import { getCookieByName } from '../Utils/Helpers';
import { Backend } from '../Backend';
import { ModalsManager } from '../Common/MadalsManager/Core';
import { CarModel } from '../Models/CarModel';

@Singleton
export class GameLogic {
    public modalsManager: ModalsManager = null;
    constructor(
        @Inject private _model: GameModel,
        @Inject private _modelEvents: ModelEvents,
        @Inject private _collisions: Collisions,
        @Inject private _storageManager: GameStorageManager,
        @Inject private _soundManager: SoundManager,
        @Inject public generator: InchGenerator,
        @Inject private _backend: Backend,
        
    ) {
        if (getCookieByName('ftue'))
            this._model.ftue = 0;
    }

    public setState(state: AppStateEnum): void {
        this._model.appState = state;
        if (state == AppStateEnum.game) {
            if (this._model.ftue) {
                this._modelEvents.dispatch(this._model, UIEvents.showFTUE);
            }
        }
    }

    public setName(name: string): boolean {
        if (!name) return false;
        this._model.playerName = name;
        return true;
    }

    // public getPlayerDistance(): number {
    //     return this._model.gasStationDistance;
    // }

    public getPlayerSpeed(): number {
        return this._model.currentPlayer.speed;
    }

    public getPlayerSpeedMax(): number {
        return this._model.currentPlayer.speedMax;
    }

    public getPlayerSpeedAcceleration(): number {
        return this._model.currentPlayer.speedFriction;
    }

    public getPlayerSpeedInKilometers(): number {
        return (this.getPlayerSpeed() / 10);
    }

    public onPlayerHitWithObstacle(): void {
        this._model.currentPlayer.speed = this._model.playerBrakeSpeed;
        // this._model.playerHealth = Math.max(0, this._model.playerHealth - 1);
        this._model.currentGas = Math.max(0, this._model.currentGas - 1);
    }

    public setPlayerRoadIndex(value: number): void {
        this._model.playerRoadIndex = value;
        this._modelEvents.dispatch(this._model, 'setPlayerRoadIndex');
    }

    public getPlayerRoadIndex(): number {
        return this._model.playerRoadIndex;
    }

    public setPlayerType(value: GamePlayerTypeEnum): void {
        this._model.playerType = value;
        this._model.fillPlayer(getCarConfigByType(value));
    }

    public getPlayerType(): GamePlayerTypeEnum {
        return this._model.playerType;
    }

    public addGasStation(): void {
        this._modelEvents.dispatch(this._model, 'addGasStation');
    }

    public applyGasStation(): void {
        this._model.gasStationCheckedCount++;
        // this._model.currentGas = this._model.currentGasInitial;
    }

    public addCoins(value: number): void {
        this._model.coins += value;
    }

    public subCoins(value: number): void {
        this._model.coins = Math.max(0, this._model.coins - value);
    }

    public getCoins(): number {
        return this._model.coins;
    }

    public useCollectable(type: GameCollectableTypeEnum): boolean {
        if (this.hasCollectable(type)) {
            this._model.collectablesState[type] = false;
            switch (type) {
                case GameCollectableTypeEnum.horse: {
                    this._modelEvents.dispatch(this._model, 'removeObstacleByType', GameObstacleTypeEnum.horse);
                    break;
                }
                case GameCollectableTypeEnum.bat: {
                    this._modelEvents.dispatch(this._model, 'removeMoveableObstacleByType', GameMoveableObstacleTypeEnum.degen);
                    break;
                }
                case GameCollectableTypeEnum.crypto: {
                    this._modelEvents.dispatch(this._model, 'removeMoveableObstacleByType', GameMoveableObstacleTypeEnum.police);
                    this._modelEvents.dispatch(this._model, 'removeMoveableObstacleByType', GameMoveableObstacleTypeEnum.policeCrown);
                    break;
                }
                case GameCollectableTypeEnum.gun: {
                    this._modelEvents.dispatch(this._model, 'removeMoveableObstacleByType', GameMoveableObstacleTypeEnum.gelandewagen);
                    break;
                }
            }

            // this._model.activeCollectables.splice(this._model.activeCollectables.indexOf(type), 1);
            this._modelEvents.dispatch(this._model, 'useCollectable', type);


            return true;
        }
        return false;
    }

    public takeCollectable(type: GameCollectableTypeEnum): void {
        this._model.collectablesState[type] = true;
        // if (!this.hasCollectable(type)) {
        //     this._model.activeCollectables.push(type);
        //     this._modelEvents.dispatch(this._model, 'takeCollectable', type);
        // }
    }

    public useHorseSpeedUp(time = this._model.horseSpeedUpTimeMax): void {
        if (this._model.horseSpeedUpTime < time)
            this._model.horseSpeedUpTime = time;
    }

    public isHorseSpeedUpEnabled(): boolean {
        return this._model.horseSpeedUpTime > 0;
    }

    public getActiveCollectables(): GameCollectableTypeEnum[] {
        //TODO: refactor
        const keys = Object.keys(this._model.collectablesState);
        const values = Object.values(this._model.collectablesState);
        const ret = [];
        for (let i = 0; i < keys.length; i++)
            if (values[i])
                ret.push(keys[i]);
        return ret;
    }

    public getTileConfig(index: number = this._model.gasStationCheckedCount): any {
        return getTileConfig(index);
    }

    public hasCollectable(boosterType: GameCollectableTypeEnum): boolean {
        return this._model.collectablesState[boosterType];
    }

    public update(deltaTime: number): void {
        this._model.playerDistance += this.getPlayerSpeed() * deltaTime;
        if (this._model.lowresCounter >= this._model.lowresTimer) {
            this.lowResUpdate();
            this._model.lowresCounter = 0;
            this._model.currentTime += deltaTime;
        } else {
            this._model.lowresCounter += deltaTime;
        }
        if (this._model.currentGas <= 0) {
            this._model.currentPlayer.speed -= 3 * this._model.currentPlayer.speedFriction * deltaTime;
        }
        if ((this._model.currentGas <= 0) && (this._model.currentPlayer.speed <= 0.0)) {
            this._soundManager.play(Sounds.END_GAME, false, 1);

            //const h2msec = (h) => ((h * 60) * 1000);

            const dist = Math.floor(this._model.playerDistance);
            const reward =  Math.ceil(dist * getCommonConfig('coinPerDistance'));
            const totalCoins = this._model.levelCoins + reward;

            const currentTime = +new Date();
            const scoreDayTime = this._backend.getState().scoreDayTimestamp * 1000;
            const scoreWeekTime = this._backend.getState().scoreWeekTimestamp * 1000;

            const scoreDayTimeDiff = Math.floor((currentTime - scoreDayTime) / 1000 / 60 / 60 / 24);
            const scoreWeekTimeDiff = Math.floor((currentTime - scoreWeekTime) / 1000 / 60 / 60 / 24);

            const currentCar = Object.keys(GamePlayerTypeEnum).indexOf(this._model.playerType);

            if (dist > this._backend.getState().scoreTotal) {
                this._backend.saveState({
                    scoreTotal: dist,
                    highestScoreCar: currentCar,
                }).catch(() => {
                    this._modelEvents.dispatch(this._model, UIEvents.showError);
                });
            }
            if (dist > this._backend.getState().scoreDay || scoreDayTimeDiff >= 1) {
                this._backend.saveState({
                    scoreDay: dist,
                    scoreDayCar: currentCar,
                    scoreDayTimestamp: Math.floor(currentTime / 1000),
                }).catch(() => {
                    this._modelEvents.dispatch(this._model, UIEvents.showError);
                });
            }
            if (dist > this._backend.getState().scoreWeek || scoreWeekTimeDiff >= 7) {
                this._backend.saveState({
                    scoreWeek: dist,
                    scoreWeekCar: currentCar,
                    scoreWeekTimestamp: Math.floor(currentTime / 1000),
                }).catch(() => {
                    this._modelEvents.dispatch(this._model, UIEvents.showError);
                });
            }
            if (totalCoins > this._backend.getState().coinsTotal) {
                this._backend.saveState({
                    coinsTotal: totalCoins,
                }).catch(() => {
                    this._modelEvents.dispatch(this._model, UIEvents.showError);
                });
            }
            if (totalCoins > this._backend.getState().coinsDay) {
                this._backend.saveState({
                    coinsDay: totalCoins,
                }).catch(() => {
                    this._modelEvents.dispatch(this._model, UIEvents.showError);
                });
            }

            this._backend.sendComplete(
                this._model.startTimestamp,
                Math.round(+new Date() / 1000),
                this._model.currentLevel,
                this._model.currentPlayer.index,
                totalCoins,
                dist,
            );
            if (this._backend.error) {
                this._modelEvents.dispatch(this._model, UIEvents.showError);

            }

            this.coinTransaction(reward)
            this.setState(AppStateEnum.endscreen);
        }

        if (this._model.highresCounter >= this._model.highresTimer) {
            this.updateHighres();
            this._model.highresCounter = 0;
        } else {
            this._model.highresCounter += deltaTime;
        }
    }

    public start(): void {
        this._model.startTimestamp = Math.round(+new Date() / 1000);
        this.resetLevel();
    }

    public resetLevel() {
        this._model.resetLevel();
        this._model.cars.forEach(car => {
            car.speed = 0;
        });
    }

    public updateHighres() {
        const period = this._model.highresCounter;

        if (this._model.currentGas > 0) {
            const maxSpeed = (this._model.horseSpeedUpTime > 0) ? this._model.currentPlayer.speedMax * this._model.horseSpeedUpPercent : this._model.currentPlayer.speedMax;

            if (this._model.currentPlayer.speed > maxSpeed) {
                this._model.currentPlayer.speed = Math.max(maxSpeed, this._model.currentPlayer.speed - this._model.currentPlayer.speedAcceleration * period);
            } else {
                this._model.currentPlayer.speed = Math.min(maxSpeed, this._model.currentPlayer.speed + this._model.currentPlayer.speedAcceleration * period);
            }
        }
        if (this._model.currentPlayer.speed < 0) this._model.currentPlayer.speed = 0;

        if (this._model.generator.floraDistance >= this._model.generator.floraDistanceMax) {
            this._model.generator.floraDistance = 0;
            this.spawnFlora();

        } else {
            this._model.generator.floraDistance += this.getPlayerSpeed() * period;
        }

        if (this._model.generator.signDistance >= this._model.generator.signDistanceNext) {
            this._model.generator.signDistance = 0;
            this.spawnDecor();
        } else {
            this._model.generator.signDistance += this.getPlayerSpeed() * period;
        }

        this._modelEvents.dispatch(this._model, EngineEvents.highResTimer);
    }

    public calcRepairPrice() {
        return (100 - this._model.currentPlayer.health) * this._model.currentPlayer.repairPrice;
    }

    public coinTransaction(recieved: number) {
        this._model.levelCoins += recieved;
        this._model.coins += recieved;

        this._backend.saveState({
            coins: this._model.coins,
        }).catch(() => {
            this._modelEvents.dispatch(this._model, UIEvents.showError);
        });
    }

    public checkInch() {
        if ((this._model.playerDistance) >= this._model.generator.trackDistance) {
            if (this._model.generator.trackIndex > -1) {
                this._model.gasStationCheckedCount++;
                // this.addGasStation();
            }
            this._model.generator.trackIndex++;
            this._model.generator.lastTrackDistane = this._model.generator.trackDistance;
            try {
                this._model.generator.trackDistance += getTileConfig(this._model.generator.trackIndex).distance;
                const obstacles: number[] = getTileConfig(this._model.generator.trackIndex).obstacles;
                this.generator.wishes = { low: obstacles[0], med: obstacles[1], high: obstacles[2] };
            } catch {
                this._model.generator.trackDistance += 14500;
                Object.keys(this.generator.wishes).forEach(key => {
                    this.generator.wishes[key]++;
                });
            }
            this.generator.currentWishes = { low: 3, med: 0, high: 0 };
            this._model.generator.obstacleDistance = (getTileConfig(this._model.generator.trackIndex).distance - getCommonConfig('beforeCheckPoint')) / (
                this.generator.wishes.low + 2 * this.generator.wishes.med + this.generator.wishes.high + 0.0000001
            )
            if (this._model.generator.obstacleDistance < getCommonConfig("obstacleDistance"))
                this._model.generator.obstacleDistance = getCommonConfig("obstacleDistance");

            if (this._model.generator.generated.length) {
                const last_gen = this._model.generator.generated.pop();
                this._model.generator.generated = [last_gen];
            }
            this._model.generator.collectables = [];

            return false;
        }
        return true;

    }

    public spawnCollectables(): boolean {
        if ((this._model.generator.trackDistance - this._model.playerDistance) < 500) return false;
        if ((this._model.playerDistance - this._model.generator.lastTrackDistane) < 500) return false;
        if (Random() < 0.4) return false;

        const lastGenerated = this._model.generator.generated[this._model.generator.generated.length - 1];
        
        let roads = [-1, 0, 1]
        if (lastGenerated)
            roads = roads.filter(r => r != lastGenerated.road);
        try{
            roads = roads.filter(r => r != this._model.generator.generated[this._model.generator.generated.length - 2].road);
        }
        catch{}
        let collectables: string[] = Object.values(GameCollectableTypeEnum).slice(1);
        collectables = collectables.filter(c => !this._model.collectablesState[c]);
        if (!collectables.length) return false;

        if (this._model.generator.collectables.length) {
            const lastSpawned = this._model.generator.collectables[this._model.generator.collectables.length - 1];
            if (750 > (this._model.playerDistance - lastSpawned.distance)) return false;
            this._model.generator.collectables.forEach(c => {
                collectables = collectables.filter(a => !(a == c.type));
            });
        }
        if (!collectables.length) return false;

        const road = sampleFromArray(roads, 0);
        const c = sampleFromArray(collectables, 0);
        this._modelEvents.dispatch(this._model, GeneratorEvenets.addCollectable, c, road);
        this._model.generator.lastObstacleDistance = this._model.playerDistance;
        this._model.generator.collectables.push({ type: c, distance: this._model.playerDistance, road });
        return true;

    }

    public lowResUpdate(): void {
        if (this._model.gameScreen.deletedObstacles.length > 5) {
            const controller = this._model.gameScreen.deletedObstacles.pop();
            this._model.gameScreen.removeChildController(controller);
        }
        let horse = false;
        if (this.checkInch())
            if (this._model.generator.unicornDistance <= this._model.playerDistance) {
                horse = true;
                // this._modelEvents.dispatch(this._model, GeneratorEvenets.addObstacle, GameObstacleTypeEnum.horse, Math.round(Random()) ? 1 : -1);
                if ((this._model.playerDistance - this._model.generator.lastObstacleDistance) >= this._model.generator.beforeStaticDistance) {
                    this._model.gameScreen.createObstacleController({
                        type: GameObstacleTypeEnum.horse,
                        roadIndex: Math.round(Random()) ? 1 : -1,
                    });
                    this._model.generator.unicornDistance = this._model.playerDistance + Random() * 2000 + 2000;
                    this._model.generator.lastObstacleDistance = this._model.playerDistance;
                }
            }
        if (((this._model.playerDistance) <= this._model.generator.trackDistance) &&
            !horse
        ) {
            this.generator.spawn();
            if (this._model.generator.lastObstacleDistance == this._model.playerDistance) {
                if (this._model.generator.generated[this._model.generator.generated.length - 1].obstacleType != GameMoveableObstacleTypeEnum.degen) {
                    this.spawnCollectables();
                }
            }
        }

        // this._model.currentGas = Math.max(0, this._model.currentGas - this._model.playerGasRate * this._model.lowresCounter);


        if (this._model.horseSpeedUpTime > 0) {
            this._model.horseSpeedUpTime -= this._model.lowresCounter;

        } else {
            this._model.horseSpeedUpTime = 0;
        }

    }

    public setCollectableState(type: GameCollectableTypeEnum, active: boolean = false) {
        this._model.collectablesState[type] = active;
    }

    private decorArray = [GameObstacleTypeEnum.flora];

    public spawnFlora() {

        this._model.gameScreen.createObstacleController({
            type: GameObstacleTypeEnum.flora,
            roadIndex: Random() + 2.5,
        });

        // this._modelEvents.dispatch(this._model, 'addObstacle', GameObstacleTypeEnum.flora, Random()+ 2.5);
        this._modelEvents.dispatch(this._model, 'addObstacle', GameObstacleTypeEnum.flora, -2.5 - Random());
    }


    public spawnDecor() {
        const random = Math.random() * 1073676287;
        this._modelEvents.dispatch(this._model, 'addObstacle', GameObstacleTypeEnum.hotel, Math.round(Math.random()) ? -2 : 2);
        this._model.generator.signDistanceNext = Math.random() * (this._model.generator.signDistanceMax - 0.4 * this._model.generator.signDistanceMax) + 0.4 * this._model.generator.signDistanceMax;
    }
}
